import { setupNextraPage } from 'nextra/setup-page'
import __nextra_layout from 'nextra-theme-docs'
import __nextra_themeConfig from '/vercel/path0/theme.config.tsx'

import 'nextra-theme-docs/style.css'
/*@jsxRuntime automatic @jsxImportSource react*/
import {useMDXComponents as _provideComponents} from "nextra/mdx";
import InitMenu from '../../src/components/InitMenu';
export const __toc = [];
function _createMdxContent(props) {
  const _components = Object.assign({
    h1: "h1",
    p: "p"
  }, _provideComponents(), props.components);
  return <><InitMenu />{"\n"}<_components.h1>{"Satori"}</_components.h1>{"\n"}<_components.p>{"Satori (悟り) is a Japanese Buddhist term for awakening, \"comprehension; understanding\"."}</_components.p></>;
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? <MDXLayout {...props}><_createMdxContent {...props} /></MDXLayout> : _createMdxContent(props);
}



const __nextraPageOptions = {
  MDXContent,
  pageOpts: {"filePath":"pages/Folder-1/satori.html.mdx","route":"/Folder-1/satori.html","timestamp":1721274127000,"pageMap":[{"kind":"Folder","name":"Folder-1","route":"/Folder-1","children":[{"kind":"Meta","data":{"satori.html":"Satori Title"}},{"kind":"MdxPage","name":"satori.html","route":"/Folder-1/satori.html"}]},{"kind":"Meta","data":{"index":"Introduction","another.html":"Another Page","about.html":{"title":"About","type":"page"},"contact":{"title":"Source ↗","type":"page","href":"https://github.com/xizon/nextjs-doc-template","newWindow":true}}},{"kind":"MdxPage","name":"about.html","route":"/about.html"},{"kind":"MdxPage","name":"another.html","route":"/another.html"},{"kind":"MdxPage","name":"index","route":"/"}],"flexsearch":{"codeblocks":true},"title":"Satori",headings:__toc},
  pageNextRoute: "/Folder-1/satori.html",
  nextraLayout: __nextra_layout,themeConfig: __nextra_themeConfig
}
if (process.env.NODE_ENV !== 'production') {
  __nextraPageOptions.hot = module.hot
  __nextraPageOptions.pageOptsChecksum = ''
}
if (typeof window === 'undefined') __nextraPageOptions.dynamicMetaModules = []

export default setupNextraPage(__nextraPageOptions)